import React from 'react'
import { Card, Container } from 'react-bootstrap'
import '../../features/products/MightyBucksGiftCardPage.scss';
import { useSelector } from 'react-redux';
import { selectToken } from '../../features/user/userSlice';
import { selectCartCoupon } from '../../features/cart/cartSlice';
import YourDiscounts from './components/YourDiscounts';
import { YourBenefits } from './components/YourBenefits';
import { WaysToSave } from './components/WaysToSave';
import { OnSaleProducts } from './components/OnSaleProducts';
import './core/mightyDealpage.scss';
import MightyBucksGiftCardPage from '../../features/products/MightyBucksGiftCardPage';

const MightyDealsWrapper = () => {
    const token = useSelector(selectToken);
    const cartCoupon = useSelector(selectCartCoupon);

    return (
        <Container className="mightyBucks-page">
            <Card body className='border-0'>
                <div className='introducing-container'>
                    <div className='introducing'>
                        <h1>Mighty<span>Deals</span></h1>
                        <h2>Lots of Ways to Save BIG!</h2>
                        <p>Discover all your current promotions and rewards at a glance!</p>
                    </div>
                </div>
                {token && !cartCoupon && <YourDiscounts />}
                {token && <YourBenefits />}
                <WaysToSave />
                <div className='pt-0'>
                    <div className='row p-2 mightybuckstext'>
                        <div className='col-md-4 text-start righttext font-poppins mt-2 pt-2 text-uppercase'>
                            Save BIG with MightyBucks!
                        </div>
                        <div className='col-md-8 lefttext font-poppins mt-2 pt-2'>
                            This innovative currency from MightyMeals not only simplifies meal ordering but also offers incredible savings-buy in bulk and save up to 10% off! With <b>each MightyBuck equivalent to $1 USD</b>, enjoying your favorite nutritious meals has never been more rewarding.
                        </div>
                    </div>
                    <MightyBucksGiftCardPage />
                </div>
                <OnSaleProducts />
            </Card>
        </Container>
    )
}

export default MightyDealsWrapper